export enum EmergencyStatusEnum {
    CONTINUE = 'CONTINUE',
	LAND = 'LAND',
	PAUSE = 'PAUSE',
	RETURN = 'RETURN',
	LOCK = 'WINCH_LOCK',
	UNLOCK = 'WINCH_UNLOCK',	
	REEL_DOWN = 'WINCH_REEL_DOWN',
	REEL_UP = 'WINCH_REEL_UP',
	STOP = 'WINCH_STOP',
}